import React from 'react'
import './map.css'
const Map = () => {
    return (
        <div className="Map-Container">
       <iframe
       className="iframe-class"
       title=" Reach us at"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.3503117383257!2d77.25442671446451!3d28.559241594146474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3b8b9938189%3A0x82400b25c2d94953!2sDr%20Sandeep%20Kumar%20Jangra&#39;s%20Dental%20Clinic%20-%20The%20White%20Expert%20Dental%20Care!5e0!3m2!1sen!2sin!4v1617950891882!5m2!1sen!2sin"
        allowfullscreen=""
        loading="lazy"
      ></iframe>     
        </div>
    )
}

export default Map;
